export const IMAGES = {
  hero: "/images/hero.jpg",
  doubleWall: "/images/double-wall.jpg",
  baristaHolding: "/images/barista-holding.jpg",
  singleWall: "/images/single-wall.jpg",
  baristaCounter: "/images/barista-counter.jpg",
  espresso: "/images/espresso.jpg",
  cuttingChai: "/images/cutting-chai.jpg",
  rippleWall: "/images/ripple-wall.jpg",
  tissue: "/images/tissue.jpg",
  glassBottle: "/images/glass-bottle.jpg",
  factory: "/images/factory.jpg",
  itPark: "/images/it-park-coffee.jpg",
};
